import { render, staticRenderFns } from "./ModuleIndex.vue?vue&type=template&id=70a4aeb8&scoped=true"
import script from "./ModuleIndex.vue?vue&type=script&lang=js"
export * from "./ModuleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a4aeb8",
  null
  
)

export default component.exports